import { CardContent, Typography, Slider, Box, InputAdornment, TextField } from "@mui/material"
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { formatInWords } from "../utils/formatInWords";

const EmergencyFunds = () => {
  const { state, actions } = useAppContext();
  
  const [value,setValue] = useState({
    emergencyFunds: state.emergencyFunds || '',
  });

  useEffect(() => {
    setValue(
      {
        emergencyFunds: state.emergencyFunds,
      }
    )
  }, [state.emergencyFunds])

  const handleChange = (field) => (e) => {
    let value = parseInt(e.target.value.replace(/,/g, ''), 10);
    if (isNaN(value)) value = 0;
    setValue((prev) => ({...prev, [field]: value}))
    actions.updateFormData(field,value)
  };
  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-IN').format(num);
  };
    // const handleSliderChange = (event, newValue) => {
    //   setValue(newValue);
    // };

    return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2}}>
          <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>Emergency Funds</Typography>
          <Typography variant="body1" component="h2" sx={{mb:2}} gutterBottom>
            How much would you like to reserve for emergencies? (ideally at least 6 months of expenses + EMIs)
            {/* <Typography variant='body2'> </Typography> */}
          </Typography>
        
          <TextField
            // label="Monthly expenses"
            value={value.emergencyFunds ? formatNumber(value.emergencyFunds) : ''}
            onChange={handleChange('emergencyFunds')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='emergency funds'
            aria-label="Emergency fund reserve amount in rupees"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>
            }}
          />
        {value.emergencyFunds >= 1000 && (
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          {formatInWords(value.emergencyFunds)}
        </Typography>)}
        </Box>
        {/* <Box sx={{ mb: 2}}>
          <Typography variant='h6' sx={{ color: 'primary.main', mb:2}}>Emergency Funds</Typography> 
        <Typography variant="body1" color="main.primary" component="h2" gutterBottom>
          How many months of expenses would you like to reserve for emergencies?
        </Typography>

          <Slider
            // value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            defaultValue={6}
            min={0}
            max={36}
            step={1}
            aria-labelledby="input-slider"
            marks={[
              { value: 0, label: '0' },
              { value: 6, label: '6' },
              { value: 12, label: '12' },
              { value: 24, label: '24' },
              { value: 36, label: '36' }
            ]}
          />
        </Box>
          <Typography sx={{mb:2}} variant='body2'>{value} months</Typography> */}
        </CardContent>
    </Box>
    )
}

export default EmergencyFunds;